import { BillingPricingMode } from "@api/shared-runtime/enums";
import {
  UNLIMITED_USAGE_LABEL,
  ZERO_USAGE_QUANTITY,
  formatUsageBillingQuantity,
  isUsageBillingCategoryUnlimited,
  type UsageBillingCategoryLine,
} from "./usage-billing-format";
import { UsageBillingUsageMeter } from "./usage-billing-usage-meter";

export function UsageBillingCategoryUsage({
  category,
}: {
  category: UsageBillingCategoryLine | undefined;
}) {
  if (!category) {
    return <span>{ZERO_USAGE_QUANTITY}</span>;
  }
  const isUnlimited = isUsageBillingCategoryUnlimited(category);
  const isOverage = category.hasPaidOverage;
  const hasAllowance =
    !isUnlimited &&
    category.pricingMode === BillingPricingMode.PerUnit &&
    category.includedQuantity !== null;
  const includedLabel = hasAllowance ? ` (${category.includedQuantity})` : "";
  return (
    <div className="flex flex-col items-end gap-1">
      <span className={isOverage ? "font-medium text-amber-600" : undefined}>
        {formatUsageBillingQuantity(category.usedQuantity)}
        {includedLabel}
      </span>
      {isUnlimited && (
        <span className="text-xs text-muted-foreground">
          {UNLIMITED_USAGE_LABEL}
        </span>
      )}
      {hasAllowance && category.includedQuantity !== null && (
        <UsageBillingUsageMeter
          usedQuantity={category.usedQuantity}
          includedQuantity={category.includedQuantity}
          isOverage={isOverage}
        />
      )}
    </div>
  );
}
